import * as fromRoot from '../../../../core/store';
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ClientUser } from '../../../../core/store/admin/users/users.interface';
import { ClientUserEditContainer } from './client-user-edit.container';
import { ClientUserCreateAction } from '../../../../core/store/admin/users/users.actions';
import { fadeInAnimation } from '../../../../animations';
import { ScrollService } from '../../../../core/services/scroll.service';

@Component({
  selector: 'admin-customer-client-create',
  templateUrl: './client-user-edit.container.html',
  styleUrls: ['./client-user-edit.container.scss'],
  animations: [fadeInAnimation],
})
export class ClientUserCreateContainer extends ClientUserEditContainer implements OnInit {

  createUser(epsUser: ClientUser) {
    this.store.dispatch(new ClientUserCreateAction(epsUser));
  }
}
